

export const validationPatterns = {
    email: {
        regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Please enter a valid email address",
    },
    phone: {
        regex: /^01[0125][0-9]{8}$/,
        message: "Please enter a valid Egyptian phone number (01xxxxxxxxx)",
    },
    password: {
        regex: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?=_~;'&-])[A-Za-z\d$@$!%*#?=_~;'&-]{9,}$/,
        message: "Password must be at least 10 characters long and contain letters, numbers, and special characters",
    },
    ssn: {
        regex: /(2|3)[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])(01|02|03|04|11|12|13|14|15|16|17|18|19|21|22|23|24|25|26|27|28|29|31|32|33|34|35|88)\d{5}/,
        message: "Please enter a valid Egyptian SSN (14 digits)",
    },
    url: {
        regex: /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/,
        message: "Please enter a valid URL",
    },
    alphanumeric: {
        regex: /^[a-zA-Z0-9]+$/,
        message: "Only letters and numbers are allowed",
    },
    numeric: {
        regex: /^\d+$/,
        message: "Only numbers are allowed",
    },
    noSpaces: {
        regex: /^\S+$/,
        message: "Spaces are not allowed",
    },
}

